<div
    *ngIf="service.getValueWithUnitName(value) as valueWithUnitName"
    #columnValue
    class="gantt-column-value width-fit-content mb-2"
    [style.marginLeft.px]="-columnValue.getBoundingClientRect().width / 2"
>
    {{ firstValue ? 0 : (valueWithUnitName.value | number: '1.0-3') }}{{ valueWithUnitName.unitName }}
</div>
<div class="gantt-border"></div>
